import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '@/views/Menu'
import Basket from '@/views/Basket'
import DishDescription from '@/components/DishDescription'
import DeliveryArea from '@/views/DeliveryArea'
import OrderCreated from '../views/OrderCreated.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Menu
  },
  {
    path: '/basket',
    component: Basket
  },
  {
    path: '/dish/:id',
    component: DishDescription,
    props: true
  },
  {
    path: '/delivery-area',
    component: DeliveryArea,
  },
	{
		path: '/order-created',
		component: OrderCreated,
	},
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
